import RerouteLessonContainer from './container';

export default RerouteLessonContainer;
